import { Box, CircularProgress, TextField, Typography } from "@mui/material";
import * as motion from "motion/react-client";
import { commonStyle } from "../common.styles";
import theme, { responsiveFontSize } from "themes/Theme";
import PrimaryButton from "components/PrimaryButton/PrimaryButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { requestActivationEmail } from "services/apiService";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { Logo } from "assets/index";

const VerifyEmailPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState<string | null>(state ? state : null);
  const [emailError, setEmailError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const handleVerifyOtp = async () => {
    try {
      if (email) {
        setLoading(true);
        const response = await requestActivationEmail(email);
        if (response && response.status === 200) {
          toast.success(response?.data?.message);
          navigate("/auth/verify-code", { state: response.data?.data });
        } else {
          toast.error(response?.data?.message);
        }
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const resetDispatch = () => {
    dispatch({ type: "RESET_ALL_STATE" });
  };

  return (
    <motion.div
      initial={{ x: "100%" }}
      animate={{ x: 0 }}
      transition={{
        type: "spring",
        stiffness: 50,
      }}
    >
      <Box>
        <center>
          <Box
            component={"img"}
            src={Logo}
            sx={{
              width: "120px",
              height: "120px",
              objectFit: "contain",
              "&:hover": { cursor: "pointer" },
            }}
            onClick={() => {
              navigate("/");
            }}
          />
        </center>
        <Typography style={commonStyle.titleText}>
          Verify your email address
        </Typography>
        <Typography sx={styles.subText}>
          enter your email to verify your account
        </Typography>

        <TextField
          value={state ? state : email}
          fullWidth
          onChange={(e) => setEmail(e.target.value)}
          variant="outlined"
          size="small"
          slotProps={{
            input: {
              style: {
                fontSize: responsiveFontSize(16),
                backgroundColor: "rgb(255, 255, 255)",
              },
            },
          }}
          sx={{ mt: 2 }}
        />
        <Typography sx={styles.errorText}>{emailError}</Typography>
        {loading ? (
          <CircularProgress sx={{ marginTop: "2em" }} />
        ) : (
          <PrimaryButton
            title="Verify Email"
            onClick={handleVerifyOtp}
            viewStyle={{ marginTop: "2em", width: "100%" }}
          />
        )}

        <Typography sx={styles.supportTextHelp}>
          Need help?{" "}
          <Link
            style={styles.supportLinkHelp}
            to="/contact-us"
            onClick={() => {
              resetDispatch();
            }}
          >
            contact customer care support
          </Link>
        </Typography>
      </Box>
    </motion.div>
  );
};
export default VerifyEmailPage;
const styles = {
  subText: {
    fontSize: responsiveFontSize(12),
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  emailIdText: {
    fontSize: responsiveFontSize(14),
    color: theme.palette.text.primary,
    fontWeight: 500,
    marginTop: "2em",
  },
  supportTextHelp: {
    fontSize: responsiveFontSize(14),
    color: theme.palette.text.primary,
    fontWeight: 500,
    marginTop: "3em",
  },
  supportLinkHelp: {
    fontSize: responsiveFontSize(14),
    color: theme.palette.primary.main,
    fontWeight: 500,
    textDecoration: "none",
  },
  errorText: {
    fontSize: responsiveFontSize(12),
    fontWidth: 400,
    color: "red",
    marginBottom: "3em",
  },
};
